// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"bab0a281","760":"f94c4a1a","787":"fa735e5f"}[chunkId] + ".chunk.js";
};